import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import HeaderLine from "../../lead-management/common/HeaderLine";
import CommonStatCard from "../../pt/pt-flow-new/CommonStatCard";
import { getCardLabel, getCardValue } from "../../common-data/Conversions";
import LeadKeywordStats from "../../automation/automation-lead-keywords/LeadKeywordStats";
import RecurringSubsStats from "../../recurring-subscriptions/RecurringSubsStats";
import RefferalStat from "../../refferals/RefferalStat";
import ODMPendingStats from "./ODMPendingStats";
import CalendarLoader from "../../common-components/CalendarLoader";

const EXCLUDED_KEYS = ["total_converted_amount"];

const STAT_ORDER = [
  "total",
  "total_pending",
  "total_completed",
  "total_converted",
  "total_not_converted",
  "total_added_to_lead",
  "total_not_added_to_lead",
];

const ODMWatiStats = ({ onNavigateToTab }) => {
  const { oneDayStatsLoading, oneDayStats } = useSelector(
    (state) => state.plans
  );

  const iniDatas = {
    allODMStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (oneDayStats?.status && oneDayStats?.data) {
      setAllDatas((prevs) => ({
        ...prevs,
        allODMStats: oneDayStats.data,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allODMStats: {},
      }));
    }
  }, [oneDayStats]);

  const sortedCards =
    allDatas.allODMStats &&
    Object?.entries(allDatas.allODMStats)
      ?.sort(([keyA], [keyB]) => {
        const indexA = STAT_ORDER.indexOf(keyA);
        const indexB = STAT_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          {!EXCLUDED_KEYS.includes(key) && (
            <CommonStatCard
              tagName={key}
              cardLabel={getCardLabel(key, false, "odm")}
              value={getCardValue(
                key,
                value || 0,
                allDatas.allODMStats?.total_converted_amount
              )}
            />
          )}
        </React.Fragment>
      ));

  return (
    <>
      <HeaderLine text="🚨 Pending LMS Alerts" />

      <ODMPendingStats onNavigateToTab={onNavigateToTab} />

      <HeaderLine text="ODM Stats" />

      <div className="cards-container cards-grid-container grid-5 pt-flow-new">
        {oneDayStatsLoading ? <CalendarLoader /> : sortedCards}
      </div>

      <HeaderLine text="Wati Lead Stats" />

      <LeadKeywordStats />

      <HeaderLine text="Recurring Subscription Stats" />

      <RecurringSubsStats isFromODM={true} />

      <HeaderLine text="Referral Stats" />

      <RefferalStat />
    </>
  );
};

export default ODMWatiStats;
